import { sharedConfig } from '@/pageConfig/shared';
import ogImage from '@/static/assets/faq/nl/og-en.png';
import { Faq } from 'contentlayer/generated';
import content from '../../../../.contentlayer/generated/Faq/faq__en-NL.mdx.json';
import type { BasePageConfig } from '../../BasePageConfig';

const QAPageJsonld = {
  '@context': 'http://schema.org/',
  '@type': 'WebPage',
  breadcrumb: 'Lemonade.com > Lemonade FAQ',
  name: 'Lemonade FAQ',
  image:
    'https://www.lemonade.com/assets/lemonade-share-image-ad9d7846f31685bfb4af89f018e4dd5d460f4e73768a8fd500bfc1f069ff853a.png',
  description:
    'Here are some answers to your most common coverage questions - from what liability insurance actually is, to what your contents insurance covers.',
};

export type Config = BasePageConfig;

export const config: Config = {
  layout: { ...sharedConfig['en-NL'].layout },
  seo: {
    title: 'Contents and Liability Insurance FAQ • Lemonade Insurance NL',
    metaTitle: 'Contents and Liability Insurance FAQ • Lemonade Insurance NL',
    description:
      'Here are some answers to your most common coverage questions - from what contents and liability insurance actually is, to what it covers.',
    jsonld: [QAPageJsonld],
    ogImage: ogImage.src,
  },
  MDXContent: content as Faq,
};
